import { render, staticRenderFns } from "./SideSheetTerm.vue?vue&type=template&id=a0dbb846&scoped=true"
import script from "./SideSheetTerm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideSheetTerm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SideSheetTerm.vue?vue&type=style&index=0&id=a0dbb846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dbb846",
  null
  
)

export default component.exports